import get from 'lodash/get';
import React, { useState } from 'react';
import { LinkComponentFragment, WebsiteLocaleFragment } from '../../../graphql.schema';
import { useIsClient } from '../../hooks/useIsClient';
import { HubspotModal } from '../HubspotModal/HubspotModal';
import ModalContent from '../ModalContent';

type Props = LinkComponentFragment & {
  className?: string;
  type?: 'primary' | 'secondary';
  hideIcon?: boolean;
  icon?: 'Arrow' | 'Chevron';
  modalButtonType: 'button' | 'link';
  websiteLocale?: WebsiteLocaleFragment;
};

const ModalButton: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isClient, key } = useIsClient();

  const modal = get(props, 'cta.modal.data.attributes', undefined) ?? (props.modal?.data ? props.modal?.data.attributes : props.modal)

  if (!modal) return null;

  return (
        <React.Fragment>
          <ModalContent setIsOpen={setIsOpen} {...props} />
          <HubspotModal websiteLocale={props.websiteLocale} {...modal} isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </React.Fragment>
  );
};

export default ModalButton;
